(function ($) {
  // disable weekends on gform datepickers
  // this applies globally at this moment, because all pickers are used for
  // appointment-related forms
  gform.addFilter( 'gform_datepicker_options_pre_init', function(optionsObj, formId, fieldId) {
    optionsObj.firstDay = 0;
		optionsObj.beforeShowDay = function(date) {
			var enableDate = true;
			var disabledDays = (typeof gFormNationalHolidays != 'undefined') ? gFormNationalHolidays : [];
			enableDate = enableDate && disabledDays.indexOf($.datepicker.formatDate('mm/dd/yy', date)) == -1;
			enableDate = enableDate && (date.getDay() != 0);
			return [enableDate, "", ""];
		};
		optionsObj.minDate = 0;
    return optionsObj;
  });
})(jQuery);